var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('empty',{attrs:{"icon":_vm.iconEmpty,"title":_vm.titleEmpty,"description":_vm.descriptionEmpty}},[(_vm.showSlot)?_vm._t("default"):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }